import template from './_modal-select-operator.pug';

export default {
  template: template(),

  props: {
    operatorOptions: {
      type: Array,
      required: true
    },
    selectedTransports: {
      type: Object,
      required: true,
    },
    selectedOperators: {
      type: Object,
      required: true,
    },
    excludedTransports: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data() {
    return {
      localSelectedOperator: {...this.selectedOperators}
    };
  },

  watch: {
    selectedOperators: {
      immediate: true,
      handler(newVal) {
        this.localSelectedOperator = {...newVal};
      }
    }
  },


  methods: {
    isOperatorDisabled() {
      return !this.selectedTransports.BUS;
    },

    closeModal() {
      // Cierra la modal sin aplicar los cambios
      this.$emit('close');
    }
  }

}
